<div class="page-header">
  <div class="page-container">
    <div class="page-header__content">
      <div class="page-header__info">
        <h2 class="page-header__title">{{ "families" | translate }}</h2>
        <span class="page-header__subtitle">{{
          "familiesSubtitle" | translate
        }}</span>
      </div>

      <div class="page-header__actions">
        <button nz-button [nzType]="'primary'" (click)="new()">
          {{ "newFamily" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="page-container">
  <div class="page-content">
    <form (submit)="searchFamilies()">
      <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
        <input style="width: 30%"
          type="text"
          nz-input
          [formControl]="searchQueryControl"
          [placeholder]="'searchFamilies' | translate"
        />
        <input style="width: 20%; margin-left: 10px; margin-right: 10px;"
        type="text"
        nz-input
        [formControl]="searchQueryControlCity"
        [placeholder]="'city' | translate"
      />
     
        <input style="width: 20%; margin-left: 10px; margin-right: 10px;"
        type="text"
        nz-input
        [formControl]="searchQueryControlResidence"
        [placeholder]="'residence' | translate"
      />

  <nz-form-control style="width: 20%; margin-left: 10px; margin-right: 10px;">
    <nz-select formControlName="haveDocumentsId" [formControl]="haveDocumentsId" >
      <nz-option *ngFor="let data of haveDocuments"
        [nzValue]="data.id"
        [nzLabel]="data.name"
      ></nz-option>
    </nz-select>
  </nz-form-control>

      </nz-input-group>
      <ng-template #suffixIconButton>
        <button nz-button nzType="primary" nzSearch>
          <i class="far fa-search"></i>
        </button>
      </ng-template>
    </form>

    <nz-table
      class="mt-2"
      [nzData]="data"
      [nzLoading]="isLoading"
      [nzFrontPagination]="false"
      [nzTotal]="tableData.total"
      [nzPageSize]="tableData.pageSize"
      [nzPageIndex]="tableData.page"
      (nzQueryParams)="tableParamsChanged($event)"
    >
      <thead>
        <tr>
          <th nzWidth="60px"></th>
          <!-- <th nzWidth="50px">ID</th> -->
          <th>{{ "representative" | translate }}</th>
          <th>{{ "phone" | translate }}</th>
          <th>{{ "address" | translate }}</th>
          <th>{{ "city" | translate }}</th>
          <th>{{ "residence" | translate }}</th>
          <th>{{ "documents" | translate }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let data of data">
          <tr>
            <td
              [nzExpand]="expandSet.has(data.id)"
              (nzExpandChange)="onExpandChange(data.id, $event)"
            ></td>
            <!-- <td>{{ data.id }}</td> -->
            <td>{{ data.representative }}</td>
            <td>{{ data.phone }}</td>
            <td>{{ data.address }}</td>
            <td>{{ data.city }}</td>
            <td>{{ data.residence }}</td>            
            <td>{{ data.documents ? 'DA' : 'NE' }}</td>
            <td class="text-right">
              <button
                nz-button
                nzSize="small"
                (click)="edit(data.id)"
                nzTooltipTitle="Izmjeni porodicu"
                nz-tooltip
              >
                <i class="far fa-pen"></i>
              </button>

              <button
                nz-button
                nzSize="small"
                class="ml-2"
                (click)="addMember(data.id)"
                nzTooltipTitle="Dodaj člana porodice"
                nz-tooltip
              >
                <i class="far fa-user-plus"></i>
              </button>

              <button
              nz-button
              nzSize="small"
              class="ml-2"
              (click)="addNote(data.id)"
              nzTooltipTitle="Dodaj Biljesku"
              nz-tooltip
            >
              <i class="far fa-comment-plus"></i>
            </button>

            <button
            nz-button
            nzSize="small"
            class="ml-2"
            (click)="addNeed(data.id)"
            nzTooltipTitle="Nova Potreba"
            nz-tooltip
          >
            <i class="far fa-comment-plus"></i>
          </button>

              <button
                nz-button
                nzSize="small"
                class="ml-2"
                (click)="addDonation(data.id)"
                nzTooltipTitle="Dodaj donaciju"
                nz-tooltip
              >
                <i class="far fa-box-heart"></i>
              </button>

              <button
                nz-button
                nzSize="small"
                class="ml-2"
                (click)="delete(data.id)"
                nzTooltipTitle="Izbriši porodicu"
                nz-tooltip
              >
                <i class="far fa-trash"></i>
              </button>
            </td>
          </tr>
          <tr [nzExpand]="expandSet.has(data.id)" >
            <h3 style="margin-left: 40px;" class="font-weight-bold">{{ "familyMembers" | translate }}</h3>
            <nz-table style="margin-left: 40px;" [nzData]="data.members" [nzShowPagination]="false">
              <thead>
                <tr>
                  <th style="background-color: #eee">
                    {{ "name" | translate }}
                  </th>
                  <th style="background-color: #eee">
                    {{ "dateOfBirth" | translate }}
                  </th>
                  <th style="background-color: #eee">
                    {{ "gender" | translate }}
                  </th>
                  <th style="background-color: #eee" nzWidth="300px">
                    {{ "note" | translate }}
                  </th>
                  <th style="background-color: #eee"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let member of data.members">
                  <td>{{ member.name }}</td>
                  <td>{{ member.dateOfBirth | date }}</td>
                  <td>{{ getGender(member.sex) }}</td>
                  <td>
                    <span
                      nz-typography
                      [nzEllipsis]="true"
                      [nzExpandable]="true"
                      [nzEllipsisRows]="2"
                      style="max-width: 300px"
                      >{{ member.note }}</span
                    >
                  </td>
                  <td class="text-right">
                    <button
                      nz-button
                      nzSize="small"
                      (click)="editFamilyMember(member.id ? member.id : 0)"
                    >
                      <i class="far fa-pen"></i>
                    </button>

                    <button
                    nz-button
                    nzSize="small"
                    class="ml-2"
                    (click)="deleteFamilyMember(member.id ? member.id : 0)"
                    nzTooltipTitle="Izbriši porodicu"
                    nz-tooltip
                  >
                    <i class="far fa-trash"></i>
                  </button>
                  </td>
                </tr>
              </tbody>
            </nz-table>

            <h3 style="margin-left: 40px;" class="mt-2 font-weight-bold">{{ "donations" | translate }}</h3>
            <nz-table style="margin-left: 40px;" [nzData]="data.donations" [nzShowPagination]="false">
              <thead>
                <tr>
                  <!-- <th style="background-color: #eee">
                    {{ "name" | translate }}
                  </th> -->
                  <th style="background-color: #eee" >
                    {{ "note" | translate }}
                  </th>
                  <th style="background-color: #eee" >
                    Kategorija
                  </th>
                  <th style="background-color: #eee" >
                   Datum
                  </th>

                  <th style="background-color: #eee" >
                  
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let donation of data.donations">
                  <!-- <td>{{ donation.name }}</td> -->
                  <td>
                    <span
                      nz-typography
                      [nzEllipsis]="true"
                      [nzExpandable]="true"
                      [nzEllipsisRows]="2"
                      style="max-width: 300px"
                      >{{ donation.note }}</span
                    >
                  </td>
                  <td>
                    <span
                      nz-typography
                      [nzEllipsis]="true"
                      [nzExpandable]="true"
                      [nzEllipsisRows]="2"
                      style="max-width: 300px"
                      >{{ donation.category ? donation.category.name : '' }}</span
                    >
                  </td>
                                    <td>
                    <span
                      nz-typography
                      [nzEllipsis]="true"
                      [nzExpandable]="true"
                      [nzEllipsisRows]="2"
                      style="max-width: 300px"
                      >{{ donation.donationDate | date }}</span
                    >
                  </td>
                  <td></td>
                    <td class="text-right">
                    <button
                    nz-button
                    nzSize="small"
                    class="ml-2"
                    (click)="deleteMemberDonation(donation.id ? donation.id : 0)"
                    nzTooltipTitle="Izbriši donaciju"
                    nz-tooltip
                  >
                    <i class="far fa-trash"></i>
                  </button>
                  </td>
                </tr>
              </tbody>
            </nz-table>

            <h3 style="margin-left: 40px;" class="mt-4 font-weight-bold">{{ "Biljeske" | translate }}</h3>
            <nz-table style="margin-left: 40px;" [nzData]="data.notes" [nzShowPagination]="false">
              <thead>
                <tr>
                  <th style="background-color: #eee">
                    {{ "Notes" | translate }}
                  </th>
                  <th style="background-color: #eee">
                   
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let note of data.notes">
                  <td>{{ note.description }}</td>
                  <td class="text-right">
                    <button
                    nz-button
                    nzSize="small"
                    class="ml-2"
                    (click)="deleteNoteDonation(note.id ? note.id : 0)"
                    nzTooltipTitle="Izbriši donaciju"
                    nz-tooltip
                  >
                    <i class="far fa-trash"></i>
                  </button>
                  </td>
                </tr>
              </tbody>
            </nz-table>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
  </div>
</div>
